import Vue from 'vue';
import VeeValidate from 'vee-validate';
import LoginComponent from './vue-components/Login.vue';
import ForgotPasswordComponent from './vue-components/ForgotPassword.vue';
import ResetPasswordComponent from './vue-components/ResetPassword.vue';
import draggable from 'vuedraggable';

/**
 * JS dependencies here:
 */
require('./bootstrap');

Vue.use(VeeValidate, {
    enableAutoClasses: true,
    classNames: {
        touched: 'is-primary', // the control has been blurred
        valid: 'is-success', // model is valid
        invalid: 'is-danger', // model is invalid
        dirty: 'is-danger' // control has been interacted with
    }
});

Vue.component('draggable', draggable); // Register draggable component
Vue.component('login-component', LoginComponent);
Vue.component('forgot-password-component', ForgotPasswordComponent);
Vue.component('reset-password-component', ResetPasswordComponent);

document.addEventListener('DOMContentLoaded', function () {
    const app = new Vue({
        el: '#app',
    });
});

if (!Object.prototype.foreach) {
    Object.defineProperty(Object.prototype, 'foreach', {
        value: function (callback, thisArg) {
            if (this == null) {
                throw new TypeError('Not an object');
            }
            thisArg = thisArg || window;
            for (var key in this) {
                if (this.hasOwnProperty(key)) {
                    callback.call(thisArg, this[key], key, this);
                }
            }
        }
    });
}
